import PropTypes from "prop-types";
import { useAuth } from "hooks";
import CUSTOMER_PORTAL_VERSIONS from "constants/customerPortalVersions";

/**
 * PortalPage
 *
 * Renders one page from the customer portal version the organization is on
 *
 * @param {Element} missionDev     Page for the standard Mission.dev portal
 * @param {Element} talentSimple   Page for the Talent Simple portal
 */
const PortalPage = ({ missionDev, talentSimple }) => {
  const { organization } = useAuth();
  const { customerPortalVersion } = organization || {};

  return customerPortalVersion === CUSTOMER_PORTAL_VERSIONS.talentSimple ? talentSimple : missionDev;
};

PortalPage.propTypes = {
  missionDev: PropTypes.element.isRequired,
  talentSimple: PropTypes.element.isRequired,
};

export default PortalPage;
